module.exports = __webpack_public_path__ + "img/mailbox.dc6aa2d6.svg";